"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changePasswordModalVisibleState = void 0;
exports.ChangePasswordModal = ChangePasswordModal;
const components_1 = require("@alcumus/components");
const react_1 = __importStar(require("react"));
const hooks_1 = require("@alcumus/hooks");
const changePassword_1 = require("./changePassword");
const Toast_1 = require("../../Toast/Toast");
const CustomModal_1 = __importDefault(require("../CustomModal"));
const recoil_1 = require("recoil");
const core_1 = require("@material-ui/core");
exports.changePasswordModalVisibleState = (0, recoil_1.atom)({
    key: 'changePasswordModalVisibleState',
    default: false,
});
const useStyles = (0, core_1.makeStyles)({
    inputLabel: {
        fontWeight: components_1.StyleVariables.fonts.weight.regular,
    },
});
function ChangePasswordModal({ t, }) {
    const classes = useStyles();
    const [visible, setVisible] = (0, recoil_1.useRecoilState)(exports.changePasswordModalVisibleState);
    const [newPassword, handleNewPasswordChange, setNewPassword] = (0, hooks_1.useStateFromInput)('');
    const [oldPassword, handleOldPasswordChange, setOldPassword] = (0, hooks_1.useStateFromInput)('');
    const [confirmedPassword, handleConfirmedPasswordChange, setConfirmedPassword,] = (0, hooks_1.useStateFromInput)('');
    const [toastProps, setToastProps] = (0, recoil_1.useRecoilState)(Toast_1.showToastState);
    const [passwordErrors, setPasswordErrors] = (0, react_1.useState)({});
    const [isUpdatingPassword, setIsUpdatingPassword] = (0, react_1.useState)(false);
    const validateNewPasswordChange = (e) => {
        const newPassword = e.target.value;
        if (newPassword.trim() === oldPassword.trim()) {
            setPasswordErrors({
                ...passwordErrors,
                newPasswordError: t('passwordErrors.newPasswordCannotBeTheSameAsOldPassword'),
            });
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { newPasswordError, ...rest } = passwordErrors;
            setPasswordErrors(rest);
            handleNewPasswordChange(e);
        }
    };
    const validateConfirmPasswordChange = (e) => {
        const confirmedPassword = e.target.value;
        if (newPassword.trim() !== confirmedPassword.trim()) {
            setPasswordErrors({
                ...passwordErrors,
                confirmedPasswordError: t('passwordErrors.newPasswordAndConfirmPasswordMustMatch'),
            });
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { confirmedPasswordError, ...rest } = passwordErrors;
            setPasswordErrors(rest);
            handleConfirmedPasswordChange(e);
        }
    };
    const handleUpdatePassword = async () => {
        if (newPassword?.trim().length && newPassword?.trim().length) {
            setIsUpdatingPassword(true);
            (0, changePassword_1.postNewPassword)(newPassword, oldPassword)
                .then(() => {
                setVisible(false);
                resetModal();
                setToastProps({
                    ...toastProps,
                    showToast: true,
                    severity: 'success',
                    message: t('passwordUpdatedSuccessfully'),
                });
            })
                .catch(() => {
                setToastProps({
                    ...toastProps,
                    showToast: true,
                    severity: 'error',
                    message: t('errorUpdatingPassword'),
                });
            })
                .finally(() => setIsUpdatingPassword(false));
        }
    };
    function resetModal() {
        if (isUpdatingPassword)
            return;
        setPasswordErrors({});
        setOldPassword('');
        setNewPassword('');
        setConfirmedPassword('');
        setVisible(false);
    }
    return (react_1.default.createElement(CustomModal_1.default, { open: visible, "data-testId": "changePasswordModal", disablePrimaryButton: !(newPassword?.length &&
            confirmedPassword?.length &&
            newPassword === confirmedPassword), headerText: t('editPassword'), primaryButtonText: t('save'), onHide: resetModal, isValidating: isUpdatingPassword, onPrimaryAction: handleUpdatePassword, modalBody: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(components_1.Input, { label: t('currentPassword'), type: "password", value: oldPassword, onChange: handleOldPasswordChange, "data-testid": "currentPasswordInput", disabled: isUpdatingPassword, required: true, labelClassName: classes.inputLabel }),
            react_1.default.createElement(components_1.Input, { label: t('newPassword'), type: "password", autoComplete: "new-password", value: newPassword, onChange: validateNewPasswordChange, "data-testid": "newPasswordInput", state: passwordErrors?.newPasswordError ? 'error' : 'default', hint: passwordErrors?.newPasswordError, required: true, labelClassName: classes.inputLabel }),
            react_1.default.createElement(components_1.Input, { label: t('confirmNewPassword'), type: "password", value: confirmedPassword, onChange: validateConfirmPasswordChange, "data-testid": "confirmedPasswordInput", state: passwordErrors?.confirmedPasswordError ? 'error' : 'default', hint: passwordErrors?.confirmedPasswordError, required: true, labelClassName: classes.inputLabel })) }));
}
